jQuery(document).ready(function() {
  var $paginationDots = $('#pagination li');
  var $pagination = $('#pagination'); // Assuming your pagination block has an ID of 'pagination'
  var $ingredientsSection = $('#footer');

  $paginationDots.on('click', function() {
    var target = $(this).data('target');
    $('html, body').animate({
      scrollTop: $(target).offset().top - 50
    }, 500);
  });

  $(window).on('scroll', function() {
    var scrollPos = $(document).scrollTop() + $(window).height() / 2; 

    // Toggle pagination visibility based on scroll position relative to the INGREDIENTS section
    var ingredientsTop = $ingredientsSection.offset().top;
    var ingredientsBottom = ingredientsTop +200;
    var windowBottom = scrollPos + $(window).height() / 2;
    //console.log(ingredientsBottom + ' ' + windowBottom);
    if (windowBottom > ingredientsBottom) {
      $pagination.fadeOut();
    } else {
      $pagination.fadeIn();
    }

    $paginationDots.each(function() {
      var $this = $(this);
      var target = $($this.data('target'));
      if (target.position().top <= scrollPos && target.position().top + target.height() > scrollPos) {
        $paginationDots.removeClass('active');
        $paginationDots.each(function() {
          var id = $(this).data('target').substring(1);
          $('.side-pagination').removeClass(id);
        });
        $this.addClass('active');
        var newClass = $this.data('target').substring(1);
        $('.side-pagination').addClass(newClass);
      }
    });
  });

  // Set initial active state
  $(window).scroll();
});

jQuery(document).ready(function() {

  //cta modal
  function init_cta_modal(){
	if( document.querySelector('#cta_modal') && !localStorage.getItem('cta_modal') ) {

        let modal_id = 'cta_modal'
        let wrapper = document.querySelector(`#${modal_id}`)
        let modalBlock = wrapper.querySelector('._modal')
        let overlay = wrapper.querySelector('._modal_overlay')
        let modal_close = wrapper.querySelector('._close')
        let body = document.body
        
        function open() {
          modalBlock.classList.add('active_modal')
          overlay.style.display = 'block'
          body.classList.add('body_active_modal')
          localStorage.removeItem( 'init_cta_modal' )
          localStorage.setItem( 'cta_modal', 'hide')
        }

        setTimeout( open, 10000 )
      
        modal_close.addEventListener('click',  function() {
            modalBlock.classList.remove('active_modal')
    		body.classList.remove('body_active_modal')
    		overlay.style.display = 'none'
        })
	    
	}
  }

  if( document.querySelector('.home_page') && 'yes' === localStorage.getItem( 'init_cta_modal' ) ){
      init_cta_modal()
  }
  //cta modal


  console.log(window)
  
    const forms = document.querySelectorAll('form[action="/cart/add"]');

    forms?.forEach(form => {
      const mainId = form.querySelector('[name="id"]').value;
      const giftId = window.giftId;
      const buyButton = form.querySelector('button');

      buyButton?.addEventListener('click', async (e) => {
          e.preventDefault();

          const cart = await fetch('/cart.js').then(res => res.json())
          const hasGift = cart.items?.some((el) => el.id === +window.giftId)

          await addProductToCart(mainId);

          if (!hasGift) {
            await addProductToCart(giftId);
          }

          window.location.href = '/cart';
      });
    })

    async function addProductToCart(id, qty = 1) {
        const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: id, quantity: qty })
        });
        return res.json();
    }
  
  //age-verification
  // if( document.querySelector('.age-verification') ){
  //   console.log(localStorage.getItem('ageVerified') !== 'yes');
  
  //   if (localStorage.getItem('ageVerified') == 'yes') {
  //     console.log('ageVerified');
  //     $('#age-verification').hide();
  //     $('html').removeClass('noscrollclass');
  //   }
  //   else{
  //     $('#age-verification').css('display', 'flex');
  //     $('html').addClass('noscrollclass');
      
  //     console.log('NoageVerified');
  //   }

  //   $('#yep-button').on('click', function() {
  //     localStorage.setItem('ageVerified', 'yes');
  //     $('#age-verification').hide();
  //     $('html').removeClass('noscrollclass');

  //     if( document.querySelector('.home_page') ){
  //       init_cta_modal()
  //     } else {
  //       localStorage.setItem( 'init_cta_modal', 'yes')
  //     }
      
  //   });

  //   $('#nope-button').on('click', function() {
  //     alert('You are not allowed to visit this site.');
  //   });
  // }
  //age-verification
  
});

document.addEventListener("DOMContentLoaded", function() {
  if( btnHero = document.querySelector('.btnhero') ){
    const btnHero = document.querySelector('.btnhero');
    
    btnHero.addEventListener('click', function(event) {
      event.preventDefault(); 
      console.log(btnHero);
      const targetId = btnHero.getAttribute('href').substring(1); 
      console.log(targetId);
      const targetElement = document.getElementById(targetId);
      console.log(targetElement);
      
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", function() {
  if( document.getElementById('hero-section') && document.getElementById('background-video') ){
    var heroSection = document.getElementById('hero-section');
    var backgroundVideo = document.getElementById('background-video');
    
    if (backgroundVideo) {
      backgroundVideo.addEventListener('loadeddata', function() {     
        //heroSection.style.backgroundImage = 'none';
        backgroundVideo.style.display = 'block'; 
      });
    }
  }
});
jQuery(window).on('load', function() {
   /* AOS.init({
      disable: false,
      startEvent: 'DOMContentLoaded',
      initClassName: 'aos-init',
      animatedClassName: 'aos-animate',
      useClassNames: false,
      disableMutationObserver: false,
      debounceDelay: 50,
      throttleDelay: 99,

      offset: 120,
      delay: 50,
      duration: 400,
      easing: 'ease',
      once: true,
      mirror: false,
      anchorPlacement: 'top-bottom',
    });*/
  //jQuery(".fancybox").fancybox();

  jQuery(".toggle-mnu").click(function() {
    jQuery(this).toggleClass("on");
    jQuery(".navbar").toggleClass('active');
    jQuery("body").toggleClass('overflow');
    jQuery("body").toggleClass('body_active_modal');
    return false;
  });

  jQuery(document).on('click','body.overflow',function() {
    jQuery('.toggle-mnu').toggleClass("on");
    jQuery(".navbar").toggleClass('active');
    jQuery("body").toggleClass('overflow');
    jQuery("body").toggleClass('body_active_modal');
  });

  var swiper = new Swiper('.slider-images .swiper-container', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
  });
/*
  var swiperRevies = new Swiper('.slider-images .swiper-container', {
       loop: false,
       slidesPerView: 1,
       spaceBetween: 0,
       navigation: {
           nextEl: '.swiper-button-next',
           prevEl: '.swiper-button-prev'
       },
   });
*/
   var swiperPeopleRevies = new Swiper('.slider-testimonials .swiper-container', {
        loop: true,
        slidesPerView: 3,
        spaceBetween: 20,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        autoplay: {
          delay: 5000,
        },
        breakpoints: {
          160: {
            slidesPerView: 1
          },
          660: {
            slidesPerView: 2,
            centeredSlides: false,
          },
          830: {
            slidesPerView: 3,
            centeredSlides: true,
          }
        }
    });
    var $ul = $('.type1 .tithome');
    var elements = $ul.children('li').length;

    for (var i = 0; i < 3; i++) {
      $ul.clone().appendTo('.logosline.type1');
    }


    //Product gallery
    if ( document.querySelector('.prod_gallery') ) {
        let args = {
				slidesPerView: 1,
                spaceBetween: 3,
				autoHeight: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    prevEl: '.swiper_btn._prev',
                    nextEl: '.swiper_btn._next'
                },
			}

		const prod_gallery = new Swiper(`.prod_gallery`, args);
    }
    //Product gallery

  
    //Marquee section
    if ( document.querySelector('.marquee_section ._slider') ) {
		
		let items = document.querySelectorAll('.marquee_section ._slider ._item')
		for ( let item of items ) {
			let width = item.offsetWidth + 1
			console.log('width', width)
			console.log('closest width', item.closest('.swiper-slide'))
			item.closest('.swiper-slide').style.cssText = `width: ${width}px !important;`
		}

    	const myCustomSlider = document.querySelectorAll('.marquee_section ._slider');

		for ( i = 0; i < myCustomSlider.length; i++ ) {

			myCustomSlider[i].classList.add('_slider_' + i);
			
			let args = {
				slidesPerView: 'auto',
                spaceBetween: 60,
				loop: true,
				speed: 7000,
				autoplay: {
				   delay: 0,
				 },
			}
			
			if ( myCustomSlider[i].getAttribute('data-reversedirection') ) {
				args.autoplay.reverseDirection = true
			}
			
			console.log('args', args)

			const swiperSlider = new Swiper(`.marquee_section ._slider_${i}`, args);

    	}
		
    }
    //Marquee section	


  
    /*
    //tabs
    if( document.querySelector('.tabs_section') ) {
      let tabs_section = document.querySelector('.tabs_section')
      let tabs_head__items = tabs_section.querySelectorAll('.tabs_head__item')
      let tabs__blocks = tabs_section.querySelectorAll('.tabs__block')
      for( let item of tabs_head__items ) {
        item.addEventListener('click',  function() {
          for( let tabs_head__item of tabs_head__items ) {
           tabs_head__item.classList.remove('active')
          }
          this.classList.add('active')
          let id = this.getAttribute('data-tab')
          for( let tabs__block of tabs__blocks ) {
            tabs__block.classList.remove('active')
          }
          tabs_section.querySelector(`.tabs__block[data-tab="${id}"]`).classList.add('active')
        })
      }
    }
    //tabs
    */
  
    //Contact us Select
    document.querySelector('body').addEventListener('click', function(e) { 
      if ( !e.target.closest('._select_block') ) {
          let allselectOptions = document.querySelectorAll('._select_options')
          for (let item of allselectOptions){
              item.classList.remove('show_options')
          }
      } 
    });
  
    let selectDivs = document.querySelectorAll('._select_block')
    let selectOptions, formData
      
    for (let sel of selectDivs) {
      sel.addEventListener('click',  function(e) {
          if ( e.target.closest('._select_header') ){
            selectOptions = sel.querySelector('._select_options')
            selectOptions.classList.toggle('show_options');
          }
      });
      
      let selectBrand = sel.querySelector('._select_val')
      /*
      let fixedOptions = sel.querySelector('.fixed__options')
      fixedOptions.addEventListener('click', function(e) { 
        if ( e.target.classList.contains('select-options__item') ) {
  
          let targetOption = e.target.innerText
          selectBrand.innerText = targetOption

          if( e.target.closest('.tabs_section') ){
            let tabs_section = e.target.closest('.tabs_section')
            let tabs__blocks = tabs_section.querySelectorAll('.tabs__block')
            let id = e.target.getAttribute('data-num')
            for( let tabs__block of tabs__blocks ) {
              tabs__block.classList.remove('active')
            }
            tabs_section.querySelector(`.tabs__block[data-tab="${id}"]`).classList.add('active')
          }
        }
        let closestselectOptions = e.target.closest('._select_options')
        closestselectOptions.classList.remove('show_options')
              
      });
      */
    }
    //Contact us Select


    //qty_block
	if( document.querySelector('.qty_block') ){
		
		let qty_blocks = document.querySelectorAll('.qty_block')
		for( let item of qty_blocks ){
			item.addEventListener('click',  function(e) {
			  let inp = item.querySelector('input[type="number"]')
			  let inpVal = +inp.value
			  if( e.target.closest('._minus') ) {
				//console.log('inp.value decr', inp.value)
				if ( inp.value > 0){
					inp.value = --inp.value

                    custom_product_form_total(true)
				}
			  } else if( e.target.closest('._plus') ) { 
				//console.log('inp.value', inp.value)
				if ( inp.value >= 0 && inp.value < 999 ){
					inp.value = ++inp.value 

                    custom_product_form_total()
				}
				//console.log('inp.value', inp.value)
			  }

              function custom_product_form_total( minus = false ) {
                if( document.querySelector('#custom_product_form__total') ){
                  let item_block = item.closest('[data-brew-varprice]')
                  let item_price = Number( item_block.getAttribute('data-brew-varprice') )
                  let custom_product_form__total = document.querySelector('#custom_product_form__total')
                  let curr_val = Number( custom_product_form__total.innerText.trim() )
                  if( curr_val ){
                    let new_total
                    if( minus ){
                      new_total = curr_val - item_price
                    } else {
                      new_total = curr_val + item_price
                    }
                    new_total = new_total.toFixed(2)
                    //new_total = Math.round(parseFloat( new_total.toFixed(2) ))
                    custom_product_form__total.innerText = new_total
                    
                  } else {
                    custom_product_form__total.innerText = item_price
                  }
                }
              }

              
				
			})
		}
	}
    //qty_block
  

    //img_adapt
    function img_adapt(mob = false){
		if( document.querySelector('img[data-desk]') ) {
			let imgs = document.querySelectorAll('img[data-desk]')
			for( let item of imgs ) {
				let src
				if( mob ){
                    src = item.getAttribute('data-mob')
				} else {
					src = item.getAttribute('data-desk')
				}
				item.src = src
			}
		}
	}
    function img_adapt_600(mob = false){
		if( document.querySelector('img[data-desk-600]') ) {
			let imgs = document.querySelectorAll('img[data-desk-600]')
			for( let item of imgs ) {
				let src
				if( mob ){
                    src = item.getAttribute('data-mob')
				} else {
					src = item.getAttribute('data-desk-600')
				}
				item.src = src
			}
		}
	}
    //img_adapt
  
	
	//bp_600
	const bp_600 = window.matchMedia( '(max-width:600px)' );
	const bpChecker_600 = function() {

	  if ( bp_600.matches === true ) {
		img_adapt_600(true)

	  } else if ( bp_600.matches === false ) {
		img_adapt_600()
	  }

	};
	bp_600.addListener( bpChecker_600 )
	bpChecker_600();
	//bp_600
  
	
	//bp_500
	const bp_500 = window.matchMedia( '(max-width:500px)' );
	const bpChecker_500 = function() {

	  if ( bp_500.matches === true ) {
		img_adapt(true)

	  } else if ( bp_500.matches === false ) {
		img_adapt()
	  }

	};
	bp_500.addListener( bpChecker_500 )
	bpChecker_500();
	//bp_500


    function prod_descriptions(){
      if( document.querySelector('product-info') ){
        let container_block = document.querySelector('product-info')
        let last = container_block.children.length
        let d1 = container_block.querySelector('.product_descr_block')
        let d2 = container_block.querySelector('.product_addl_descr_block')
        container_block.insertBefore( d1, container_block.children[last] )
        container_block.insertBefore( d2, container_block.children[last] )
      }
    }
  
	
	//bp_749
	const bp_749 = window.matchMedia( '(max-width:749px)' );
	const bpChecker_749 = function() {

	  if ( bp_749.matches === true ) {
		//prod_descriptions()

	  } else if ( bp_749.matches === false ) {
		
	  }

	};
	bp_749.addListener( bpChecker_749 )
	bpChecker_749();
	//bp_749


    //bp_991
    const bp_991 = window.matchMedia( '(max-width:991px)' );
    
    let featured_articles_slider
    
    const enable_featured_articles_slider = function() {
    
        if ( document.querySelector('.featured_articles_slider ') ) {
              featured_articles_slider = new Swiper('.featured_articles_slider', {
                  slidesPerView: 'auto',
                  spaceBetween: 34,
                    navigation: {
                        prevEl: '.swiper_btn._prev',
                        nextEl: '.swiper_btn._next'
                    },
              })
        }
    
    };
    const bpChecker_991 = function() {
    
        if ( bp_991.matches === true ) {
                
             return enable_featured_articles_slider()
              
        } else if ( bp_991.matches === false ) { 
                
            if ( featured_articles_slider !== undefined ) {
                featured_articles_slider.destroy( true, true )
            }
                
            return
        }
    };
    bp_991.addListener( bpChecker_991 )
    bpChecker_991()
    //bp_991

  

    if( document.body.clientWidth >= 768 ) {
  
      const horizontalSections = gsap.utils.toArray('.horizontal_slider')
      
      horizontalSections.forEach(function (sec, i) {
  
        const pinWrap = sec.querySelector("._pin_wrap");
  
        let pinWrapWidth;
        let horizontalScrollLength;
        
        function refresh() {
          pinWrapWidth = pinWrap.scrollWidth;
          horizontalScrollLength = pinWrapWidth - window.innerWidth;
        }
  
        // window.addEventListener("load", function () {
          refresh();
          // Pinning and horizontal scrolling
          let scrollTween = gsap.to(pinWrap, {
            scrollTrigger: {
              scrub: true,
              trigger: sec,
              pin: sec,
              start: "center center",
              end: () => `+=${pinWrapWidth}`,
              invalidateOnRefresh: true,
              //markers: true
            },
            x: () => -horizontalScrollLength,
            ease: "none"
          });
          
          ScrollTrigger.addEventListener("refreshInit", refresh);
      })
    }

  
});

